export const submitButton = { width: "100px", height: "36px", gap: 0 };
export const cancelButton = {
  marginRight: "1rem",
  borderRadius: "0",
  color: "#565656",
  height: "36px",
  width: "80px",
  backgroundColor: "#fff",
};

const accountTypeOptions = [
  {
    label: "Member",
    _id: "member",
  },
  {
    label: "Not a Member",
    _id: "non-member",
  },
  {
    label: "Organization",
    _id: "organization",
  },
];

export const header = (
  billingData,
  loadingBilling,
  handleChange,
  categoryData,
  loadingCategory,
  openTag,
  setOpenTag,
  contactTag,
  setContactTag,
  handleSearch,
  noOpenTag,
  setNoOpenTag,
  noContactTag,
  setNoContactTag
) => {
  const getBilling = billingData?.result?.map((item) => {
    return {
      label: item?.title,
      _id: item?._id,
    };
  });

  const getCategory = categoryData?.result?.map((item) => {
    return {
      label: item?.title,
      _id: item?._id,
    };
  });
  return [
    {
      fieldKey: "text",
      title: "Account Name",
      name: "account_name",
      placeholder: "Search",
      grid: 4,
      onChange: handleSearch,
    },
    {
      grid: 4,
    },
    {
      grid: 4,
    },
    {
      fieldKey: "select",
      title: "Account Type",
      options: accountTypeOptions ?? [],
      name: `account_type`,
      grid: 4,
      handleChange,
      loading: loadingCategory,
      mandatory: false,
      isClearable: true,
    },
    {
      fieldKey: "select",
      title: "By Category",
      options: getCategory ?? [],
      name: `category`,
      loading: loadingCategory,
      grid: 4,
      mandatory: false,
      isClearable: true,
    },
    {
      fieldKey: "select",
      title: "By Billing Type",
      options: getBilling,
      name: `billing_type`,
      loading: loadingBilling,
      grid: 4,
      isClearable: true,
      mandatory: false,
    },
    {
      fieldKey: "tag",
      grid: 4,
      name: "accountTags",
      open: openTag,
      setOpen: setOpenTag,
      label: "Account Tags",
    },
    {
      fieldKey: "tag",
      grid: 4,
      name: "contactTags",
      open: contactTag,
      setOpen: setContactTag,
      label: "Contact Tags",
      tagType: "contact",
    },
    { grid: 4 },
    {
      fieldKey: "tag",
      grid: 4,
      name: "accountNoTag",
      open: noOpenTag,
      setOpen: setNoOpenTag,
      label: "Doesn’t have Account Tags",
    },
    {
      fieldKey: "tag",
      grid: 4,
      name: "contactNoTag",
      open: noContactTag,
      setOpen: setNoContactTag,
      label: "Doesn’t have Contact Tags",
      tagType: "contact",
    },
  ];
};
